module.exports = __webpack_public_path__ + "static/media/bg-image-7.b47aa6a7.jpg";